import React from 'react';
import { NavLink } from 'react-router-dom';
import ReactPlayer from 'react-player';

var img1 = require('../../images/about.mp4');
var img2 = require('../../images/about-image.jpg')

class OurValue2 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-7 col-sm-6">
                                    <div className="video-section-full-v2">
                                        <div className="video-section-full bg-no-repeat bg-cover overlay-wraper m-b30" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                            <div className="overlay-main bg-black opacity-04" />
                                            <div className="video-section-inner">
                                                <div className="video-section-content">
                                                    <div className="video-section-left">
                                                        <button type="button" className="play-now" data-toggle="modal" data-target="#myModal">
                                                            Open Modal
                                                            <i className="icon fa fa-play" />
                                                            <span className="ripple" />
                                                        </button>
                                                    </div>
                                                    <div className="video-section-right">
                                                        <NavLink to={"#"} className="font-weight-600 text-uppercase" onClick={this.openModal}></NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Side Content Updated Here */}
                                <div className="col-md-5 col-sm-6">
                                    <div className="work-process-content">
                                        <h3><span className="font-weight-100">Our Work Process</span></h3>
                                        <h4>From Idea to Installation—Seamlessly Simple</h4>
                                        <p>You’ll work with the same trusted team throughout—no hand-offs, no surprises.</p>
                                        <ol>
                                            <li><strong>Consultation:</strong> Visit our Uxbridge showroom to explore materials and discuss your vision.</li>
                                            <li><strong>Design & Planning:</strong> We measure, sketch, and refine every detail with you.</li>
                                            <li><strong>Craft & Install:</strong> With your approval, we custom-make and professionally install your interiors.</li>
                                        </ol>
                                    </div>
                                </div>
                                {/* End Right Side Content */}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="myModal" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <video autoPlay muted loop className="slide-video">
                                <source src={img1} type="video/mp4" />
                            </video>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurValue2;
